<template>
  <el-alert
    v-if="pendingRevision"
    :title="`Kopia robocza z ${getTimestampFormatted(pendingRevision.created)}`"
    show-icon
    :closable="false"
    type="warning"
  >
    <span
      >Edytujesz kopie roboczą, zmiany nie zostaną opublikowane do momentu
      Zatwierdzenia formularza i ustalenia daty publikacji. <br />Autor zmian:
      <i class="fa fa-user" /> {{ pendingRevision.author_name }}</span
    >
  </el-alert>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    pendingRevision: {
      type: Object,
      required: false
    }
  },
  methods: {
    getTimestampFormatted(timestamp) {
      return moment(String(timestamp)).format('DD/MM/YYYY HH:mm:ss')
    }
  }
}
</script>
